import React, { useRef } from "react";
import html2canvas from "html2canvas";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./TradeFlyer.css";
import { faShare } from "@fortawesome/free-solid-svg-icons";

export default function TradeFlyer({ suggestion }) {
  const flyerRef = useRef();

  const {
    token,
    analysis,
    longPosition,
    shortPosition,
    currentPrice,
    timestamp,
  } = suggestion;

  const recommendation = analysis?.recommendation?.toUpperCase() || "N/A";
  const confidence = analysis?.confidenceLevel || "N/A";
  const trend = analysis?.trendStrength || "N/A";
  const date = new Date(timestamp).toLocaleString();

  const isBuy = recommendation === "BUY" || recommendation === "STRONG BUY";
  const isSell = recommendation === "SELL" || recommendation === "STRONG SELL";

  const entry = isBuy
    ? longPosition?.entry
    : isSell
    ? shortPosition?.entry
    : null;

  const tp = isBuy
    ? longPosition?.tp
    : isSell
    ? shortPosition?.tp
    : null;

  const sl = isBuy
    ? longPosition?.sl
    : isSell
    ? shortPosition?.sl
    : null;

  const generateImageAndShare = async () => {
    // Render flyer off-screen and share on click
    const canvas = await html2canvas(flyerRef.current);
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
const safeToken = token.replace(/[\/\\?%*:|"<>]/g, '-');
const fileName = `TrendScout-${safeToken}.png`;
const file = new File([blob], fileName, { type: 'image/png' });


  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    const binanceUrl = `https://www.binance.com/en/trade/${token.replace("/", "_")}`;
    const scoutUrl   = "https://www.trendscout.club";
      try {
   await navigator.share({
     title: `AI Trade Flyer: ${token}`,
     text:
       `Check out this AI trade recommendation from Trend Scout!\n\n` +
       `🔗 Binance chart: ${binanceUrl}\n` +
       `🌐 More at: ${scoutUrl}`,
     files: [file],
   });
      } catch (error) {
        console.error("Sharing failed:", error);
      }
    } else {
      alert("Sharing is not supported on this device.");
    }
  };

  return (
    <div>
      {/* Hidden off-screen flyer for html2canvas capture */}
      <div
        ref={flyerRef}
        className="flyer-container"
        style={{ position: 'absolute', top: 0, left: '-10000px' }}
      >
        <img src="/Logo.jpg" alt="Trend Scout" className="flyer-logo" />
        <h2 className="flyer-title">{token} AI Trade</h2>
        <p className="flyer-tag">{recommendation} | Confidence {confidence}/10</p>
        <p className="flyer-trend">📊 Trend: {trend}</p>
        <p>📈 Entry: {entry ? `$${entry}` : "N/A"}</p>
        <p>🎯 TP: {tp ? `$${tp}` : "N/A"}</p>
        <p>🛡️ SL: {sl ? `$${sl}` : "N/A"}</p>
        <p>💰 Price Now: ${currentPrice?.toFixed(4)}</p>
        <p className="flyer-time">🕒 {date}</p>
        <p className="flyer-link">🌐 trendscout.club</p>
      </div>
    <FontAwesomeIcon
      icon={faShare}
      onClick={generateImageAndShare}
      title="Share Trade"
      className="share-link icon-button"
    />
    </div>
  );
}
